
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.828 1.62a2.95 2.95 0 00-2.573-.52c-.356.094-.736.23-1.131.374-.716.259-1.455.526-2.122.526-1.36 0-3.07-.489-4.726-.961C10.49.528 8.641 0 7.002 0 4.948 0 2.939.813 1.615 1.496A2.984 2.984 0 000 4.159V23a1 1 0 102 0v-7.437C2.892 15.054 4.981 14 7.002 14c1.348 0 3.039.48 4.68.948 1.774.507 3.693 1.052 5.32 1.052 1.804 0 3.713-.436 5.107-1.167 1.203-.63 1.893-1.643 1.893-2.78V4.004c0-.941-.428-1.811-1.174-2.384zM4.999 12.235c-1.148.256-2.197.681-2.999 1.068V9.562c.594-.34 1.718-.919 2.999-1.269v3.942zm0-6.001c-1.148.256-2.197.681-3 1.068V4.158a.99.99 0 01.532-.885 13.1 13.1 0 012.468-.977v3.938zm5.999 6.446C9.624 12.308 8.252 12 7.001 12h-.003V8c1.162 0 2.579.357 3.999.755v3.924zm0-5.999c-1.375-.373-2.748-.68-4-.68V2H7c1.162 0 2.578.356 3.998.755v3.926zm6 7.32c-1.163 0-2.58-.357-4.001-.756V9.321c1.375.373 2.749.681 4.001.681v4zm0-6c-1.162 0-2.58-.357-4-.756V3.319c1.375.373 2.749.681 4.001.681v4zm5.001 4.053c0 .479-.446.812-.82 1.009-.621.325-1.377.578-2.182.738V9.837c1.158-.18 2.213-.48 3.002-.745v2.961zm0-5.086c-.641.243-1.747.616-3.001.841V3.634c.278-.09.546-.187.804-.28.337-.122.659-.24.962-.32.401-.105.7.062.842.171a1 1 0 01.394.799v2.963z"}})])
          )
        }
      }
    